import { parseEntityItemId } from '@wix/a11y-rules';
import { useErrorHandler, useHttpClient } from '@wix/fe-essentials/react';
import _ from 'lodash';
import { useCallback } from 'react';
import { fetchProGalleryItems } from '../../api/tpa-apis/pro-gallery/fetch-pro-gallery-items';
import { updateGalleryItems } from '../../api/tpa-apis/pro-gallery/update-gallery-items';
export const useSetGalleryItemsV2 = () => {
  const httpClient = useHttpClient();
  const errorHandler = useErrorHandler();
  const setGalleryItems = useCallback(async galleryItemsData => {
    const galleryDataById = _.groupBy(galleryItemsData, _ref => {
      let {
        tpaData
      } = _ref;
      return (tpaData == null ? void 0 : tpaData.entityId) ?? '';
    });
    const galleriesDataMap = await fetchGalleriesDataMap(httpClient, errorHandler, Object.keys(galleryDataById));
    const galleryUpdatePromises = Object.entries(galleryDataById).map(async _ref2 => {
      let [galleryId, galleryItems] = _ref2;
      const updatedGalleryItems = (galleryItems == null ? void 0 : galleryItems.map(_ref3 => {
        var _galleriesDataMap$get;
        let {
          alt,
          id
        } = _ref3;
        const itemId = parseEntityItemId(id, 1).itemId;
        const originalGalleryItem = (galleriesDataMap == null || (_galleriesDataMap$get = galleriesDataMap.get(galleryId)) == null ? void 0 : _galleriesDataMap$get.find(item => item.id === itemId)) ?? {};
        const updatedGalleryItem = {
          ...originalGalleryItem,
          alt
        };
        return updatedGalleryItem;
      })) ?? [];
      return updateGalleryItems(httpClient, errorHandler, galleryId, updatedGalleryItems);
    });
    const updatedGalleries = await Promise.all(galleryUpdatePromises);
    return updatedGalleries;
  }, [errorHandler, httpClient]);
  return {
    updateGalleryItems: setGalleryItems
  };
};
const fetchGalleriesDataMap = async (httpClient, errorHandler, galleryIds) => {
  const galleryDataMap = new Map();
  await Promise.all(galleryIds.map(async galleryId => {
    const data = await fetchProGalleryItems(httpClient, errorHandler, galleryId);
    galleryDataMap.set(galleryId, data);
  }));
  return galleryDataMap;
};
//# sourceMappingURL=use-set-gallery-items-v2.js.map